import { initContract } from '@ts-rest/core';
import { z } from 'zod';
const c = initContract();
/** Dashboard scope: the whole organization or a single billing centre. */
export const DashboardOwnerQuerySchema = z.object({
    ownerId: z.string().min(1, 'ownerId is required'),
    ownerType: z.enum(['organization', 'site']),
});
export const NameCountSchema = z.object({
    name: z.string(),
    count: z.number(),
});
export const DashboardSummarySchema = z.object({
    lines: z.object({
        total: z.number(),
        statusCounts: z.record(z.number()),
        networkStats: z.array(NameCountSchema),
        planStats: z.array(NameCountSchema),
        typeStats: z.array(NameCountSchema),
        siteStats: z.array(NameCountSchema),
    }),
    orders: z.object({
        /** Calendar year `total` and `statusCounts` cover. */
        year: z.number(),
        total: z.number(),
        statusCounts: z.record(z.number()),
        /** Orders still in flight, all years included. */
        activeStatusCounts: z.record(z.number()),
    }),
    invoices: z.object({
        countsByMonth: z.array(z.object({ month: z.string(), count: z.number() })),
    }),
    generatedAt: z.string(),
});
export const DashboardSimStockSchema = z.object({
    total: z.number(),
    byOperator: z.array(NameCountSchema),
    generatedAt: z.string(),
});
export const DashboardBillingTopLineSchema = z.object({
    mobileLineId: z.string(),
    number: z.string(),
    name: z.string().nullable(),
    amount: z.number(),
});
export const DashboardBillingSummarySchema = z.object({
    month: z.number(),
    year: z.number(),
    hasData: z.boolean(),
    subscriptionTotal: z.number(),
    consumptionTotal: z.number(),
    total: z.number(),
    topConsumingLines: z.array(DashboardBillingTopLineSchema),
    generatedAt: z.string(),
});
export const dashboardContract = c.router({
    getDashboardSummary: {
        method: 'GET',
        path: '/dashboard/summary',
        query: DashboardOwnerQuerySchema,
        responses: {
            200: DashboardSummarySchema,
        },
        summary: 'Lines / orders / invoices dashboard summary',
    },
    getDashboardSimStock: {
        method: 'GET',
        path: '/dashboard/sim-stock',
        query: DashboardOwnerQuerySchema,
        responses: {
            200: DashboardSimStockSchema,
        },
        summary: 'Free SIM stock summary',
    },
    getDashboardBilling: {
        method: 'GET',
        path: '/dashboard/billing',
        query: DashboardOwnerQuerySchema,
        responses: {
            200: DashboardBillingSummarySchema,
        },
        summary: 'Latest published billing summary',
    },
});
